<t4-container title="{{ 'Turbo.Settings.TrailerPoint.pnlSettings' | translate : 'Settings' }}">
  <span>Radius (meter): </span><b class="gridSizeValue"></b>
  <mat-slider discrete min="25" max="150" *ngIf="Settings.isInAny(['LocationManager'])"  style="margin-top: 10px;">
    <input matSliderThumb [(ngModel)]="gridsize" (ngModelChange)="updateSetting($event)" />
  </mat-slider>

</t4-container>



<t4-container title="{{ 'Turbo.Settings.TrailerPoint.pnlMap' | translate : 'Map' }}">
  <div class="mapContainer">
    <div #gmap style="height: calc(100vh - 900px); min-height: 1200px; width: 100%;"></div>
    <div class="mapFunctions">
      <div class="mapFilterBox">
        <mat-form-field>
          <input #txtMapSearch matInput placeholder="{{ 'Turbo.OneWay.Map.lblLocationSearch' | translate : 'Find location'}}" type="text"  (focus)="onSearchFocus()" />
        </mat-form-field>
      </div>
    </div>
  </div>
</t4-container>
